<template>
    <div class="department">
        <Head-view :showStyle="0"></Head-view>
        <div class="main">
            <div class="breadcrumb">部门管理</div>

            <div class="showTba">
                <div class="leftBox">
                    <div
                        class="departmentBox marginRight_32"
                        v-for="(item, key) in departData"
                        :key="key"
                        @click.stop="setDepartName(item, key)"
                    >
                        {{ item.name }}
                        <i class="del" @click.stop="delDepart(item, key)"></i>
                    </div>
                </div>
                <div class="rightBox">
                    <div class="addDepartmentBtn" @click="addDepart()">
                        添加部门
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeadView from "@/components/HeadView";
export default {
    name: "department",
    data() {
        return {
            departData: [],
            insId: "",
        };
    },

    components: {
        HeadView,
    },

    mounted() {
        this.insId = Number(localStorage.getItem("insId"));
        this.departMsgInfo();
    },

    methods: {
        departMsgInfo() {
            let data = {
                insId: this.insId,
                token: this.getCookie(),
            };
            this.request
                .post(this.baseUrl + "institution/getDeptList", data)
                .then((res) => {
                    if (res.code == 0) {
                        this.departData = res.data;
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                    // if (res == "-101") {
                    //     this.$message({
                    //         type: "error",
                    //         message: "登录过期，请重新登录",
                    //     });
                    //     setTimeout(() => {
                    //         this.$message.closeAll();
                    //         this.$router.replace("/login");
                    //     }, 500);
                    // }
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: err,
                    });
                });
        },

        addDepart() {
            this.$prompt("部门名称:", "添加部门", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
            })
                .then(({ value }) => {
                    if (!value || value.trim() == "") {
                        this.$message({
                            type: "warning",
                            message: "部门名称不能为空",
                        });
                        return;
                    }
                    let data = {
                        token: this.getCookie(),
                        name: value,
                        insId: this.insId,
                    };
                    this.request
                        .post(this.baseUrl + "institution/addDept", data)
                        .then((res) => {
                            if (res.code == 0 && res.data.result) {
                                this.$message({
                                    type: "success",
                                    message: "成功添加",
                                });
                                this.departMsgInfo();
                            } else {
                                this.$message({
                                    type: "warning",
                                    message: res.msg,
                                });
                            }
                        })
                        .catch((err) => {
                            this.$message({
                                type: "error",
                                message: err,
                            });
                        });
                })
                .catch(() => {});
        },

        delDepart(item, key) {
            this.$confirm(
                `该部门下有${item.staffCount}个人员。确定删除吗？`,
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    let data = {
                        token: this.getCookie(),
                        deptId: item.deptId,
                    };
                    this.request
                        .post(this.baseUrl + "/institution/deleteDept", data)
                        .then((res) => {
                            if (res.code == 0 && res.data.result) {
                                this.departData.splice(key, 1);
                                this.$message({
                                    type: "success",
                                    message: "删除成功",
                                });
                            } else {
                                this.$message({
                                    type: "warning",
                                    message: res.msg,
                                });
                            }
                        })
                        .catch((err) => {
                            this.$message({
                                type: "error",
                                message: err,
                            });
                        });
                })
                .catch(() => {});
        },

        setDepartName(item, key) {
            this.$prompt("部门名称:", "修改部门名称", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputValue: item.name
            })
                .then(({ value }) => {
                    if (!value || value.trim() == "") {
                        this.$message({
                            type: "warning",
                            message: "部门名称不能为空",
                        });
                        return;
                    }
                    let data = {
                        token: this.getCookie(),
                        name: value,
                        deptId: item.deptId,
                    };
                    this.request
                        .post(this.baseUrl + "institution/updateDept", data)
                        .then((res) => {
                            if (res.code == 0 && res.data.result) {
                                this.departData[key]["name"] = value;
                                this.$message({
                                    type: "success",
                                    message: "修改成功",
                                });
                            } else {
                                this.$message({
                                    type: "warning",
                                    message: res.msg,
                                });
                            }
                        })
                        .catch((err) => {
                            this.$message({
                                type: "error",
                                message: err,
                            });
                        });
                })
                .catch(() => {});
        },
    },
};
</script>

<style lang="less" scoped>
.department {
    height: 100vh;

    .main {
        margin-right: 24px;
        padding: 72px 0 0 227px;
        .breadcrumb {
            margin-left: 7px;
            color: rgba(84, 85, 86, 1);
            font-size: 12px;
            line-height: 20px;
            font-weight: 400;
        }
        .showTba {
            display: flex;
            flex-direction: row;
            margin-top: 24px;
            margin-right: 7px;
            padding: 14px 17px 0 24px;
            height: 692px;
            background: #fff;

            .leftBox {
                padding-top: 14px;
                width: 90%;

                .departmentBox {
                    position: relative;
                    padding-left: 15px;
                    float: left;
                    width: 213px;
                    height: 40px;
                    line-height: 40px;
                    background: rgba(255, 255, 255, 1);
                    border: 1px solid rgba(220, 223, 230, 1);
                    border-radius: 4px;
                    color: rgba(56, 56, 56, 1);
                    font-size: 12px;
                    font-weight: 500;
                    cursor: pointer;
                    .del {
                        position: absolute;
                        right: -8px;
                        top: -8px;
                        width: 16px;
                        height: 16px;
                        background: url("../../assets/delect.png") no-repeat
                            center center;
                        background-size: 16px 16px;
                        cursor: pointer;
                    }
                }

                .marginRight_32 {
                    margin-right: 32px;
                    margin-bottom: 15px;
                }
            }

            .rightBox {
                width: 10%;

                .addDepartmentBtn {
                    float: right;
                    width: 96px;
                    height: 40px;
                    background: rgba(4, 134, 254, 1);
                    cursor: pointer;
                    color: rgba(255, 255, 255, 1);
                    font-size: 14px;
                    font-weight: 500;
                    text-align: center;
                    line-height: 40px;
                    border-radius: 4px;
                }
            }
        }
    }
}
</style>